import React from "react";
import "../css/FBOHeaderBar.css";

const FBOHeaderBar = ({ title, backContent }) => {
  return (
    <header className="fbo-header-bar-container">
      <div className="fbo-header-bar">
        <div className="fbo-header-bar-left">
          {backContent}
        </div>
        <div className="fbo-header-bar-center">{title}</div>
        <div className="fbo-header-bar-right"></div>
      </div>
    </header>
  );
};

export default FBOHeaderBar;
